module.exports = __webpack_public_path__ + "img/rule-text2.f39b80ed.png";